import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const DashboardContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  gap: 1rem;
`

export const DashboardEmptyContainer = styled.div`
  position: relative;
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1 {
    margin-top: 22px;
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0px;
    color: ${props => props.theme.colors.color565e6b};
  }

  span {
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 20px;
    color: ${props => props.theme.colors.color565e6b};
    text-align: center;
  }
`

export const Section = styled.div`
  position: relative;
  width: 100%;
  max-width: 250px;
  min-width: 220px;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  color: ${props => props.theme.colors.color6b7786};
  font-size: 12px;
  line-height: 30px;
`
export const UrineCultureContent = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  flex: 1;
  width: 100%;
  max-height: 100vh;
  display: grid;
  grid-template-columns: 70% calc(30% - 8px);
  column-gap: 0.5rem;

  @media screen and (max-width: 1400px) {
    grid-template-columns: 1fr;
    row-gap: 0.5rem;
  }

  overflow-y: scroll;

  ${VerticalStyledScrollBar}
`
export const LeftContainer = styled.div`
  gap: 0.5rem;
  display: grid;
  grid-template-rows: auto;
  grid-auto-flow: dense;
  max-height: calc(100vh - 192px);
`
export const RightContainer = styled.div`
  gap: 0.5rem;
  display: grid;
  grid-template-rows: auto;
  grid-auto-flow: dense;
  max-height: calc(100vh - 192px);
  @media screen and (max-width: 1400px) {
    grid-template-columns: 1fr 1fr;
    row-gap: 0.5rem;
  }
`
